import APIService from "./API.service";
const queryString = require("query-string");

class AnalyticsService extends APIService {
  // Get Analytics Url
  getAnalyticsDashboardEmbedUrl(
    dashboardType: string = "",
    eventId: number = 0,
    userId: number = 0
  ): Promise<{ dashboardEmbedUrl: string, isFdInsightsActive: boolean }> {
    const query = {
      dashboardType,
      eventId,
      userId,
    };

    return this.call.get(`${this.apiUrl}?${queryString.stringify(query)}`);
  }
}

export default AnalyticsService;
